import React from 'react'
import { Fragment } from 'react'
import PropTypes from 'prop-types';
import { CustomInput } from 'reactstrap';
import { isIterableArray } from '../../../helpers/utils';
const PaginationInfo = ({ perPage,itemsPerPage = [6, 10, 15, 20, 50, 100], preText = 'Mostrando', posText = '', meta }) => {
    const { total, from, to } = meta;
    const currentPerPage = Number(meta?.perPage);
    const hasCurrentOption =
        isIterableArray(itemsPerPage) &&
        itemsPerPage.some((value) => Number(value) === currentPerPage);
    return  <>
                <CustomInput
                    id="itemsPerPage"
                    type="select"
                    bsSize="sm"
                    {...(hasCurrentOption ? { value: currentPerPage } : {})}
                    onChange={({ target }) => perPage(Number(target.value))}
                >
                    {isIterableArray(itemsPerPage) &&
                        (itemsPerPage.map((value, idx) =>
                            <option key={idx} value={value}>{value}</option>
                        ))
                    }
                </CustomInput>
                <h6 className="mb-0 text-nowrap ml-2">
                    {preText} {from}-{to} de {total} {posText}
                </h6>
            </>
}

PaginationInfo.propTypes = {
    itemsPerPage: PropTypes.array,
    perPage: PropTypes.func.isRequired,
    preText: PropTypes.string,
    posText: PropTypes.string,
    meta:PropTypes.object.isRequired
}

export default PaginationInfo;